export const SET_CONFIG = 'SET_CONFIG';
export const SET_USER = 'SET_USER';
